/**
 * Action type to signal the closing of the participants pane.
 */
export const PARTICIPANTS_PANE_CLOSE = 'PARTICIPANTS_PANE_CLOSE';

/**
 * Action type to signal the opening of the participants pane.
 */
export const PARTICIPANTS_PANE_OPEN = 'PARTICIPANTS_PANE_OPEN';

/**
 * Action type to set the volume of the participant.
 */
export const SET_VOLUME = 'SET_VOLUME';
